import { render, staticRenderFns } from "./IsFurnished.vue?vue&type=template&id=6f2e2588&"
import script from "./IsFurnished.vue?vue&type=script&lang=ts&"
export * from "./IsFurnished.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports